import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { css } from '@emotion/react';
import { Box, Grid } from 'components/box';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer } from '../../../redux/global/actions';
import { RootState } from 'typesafe-actions';
import { zIndices } from '../../../constants/z-indices';

const OutsideAlerter = dynamic(
  () => import('components/_shared/elements/outside-alerter')
);
const Login = dynamic(() => import('components/customer/login'));
const CreateAccount = dynamic(
  () => import('components/customer/create-account')
);
const RequestPasswordReset = dynamic(
  () => import('components/customer/request-password-reset')
);
const Cart = dynamic(() => import('components/cart/side-drawer'));
const MobileNav = dynamic(() => import('./mobile-nav'));

const Content = ({ active }: { active: string }) => {
  switch (active) {
    case 'cart':
      return <Cart />;
    case 'login':
      return (
        <Box py={3}>
          <Login
            headerText="Log in"
            showCloseBtn
            showCreateAccountBtn
            showFirstTimeCustomersMessage
          />
        </Box>
      );
    case 'createAccount':
      return (
        <Box py={3}>
          <CreateAccount showCloseBtn showLoginBtn />
        </Box>
      );
    case 'forgot':
      return (
        <Box py={3}>
          <RequestPasswordReset showCloseBtn showLoginBtn />
        </Box>
      );
    case 'mobileNavigation':
    default:
      return (
        <Box py={3}>
          <MobileNav />
        </Box>
      );
  }
};

const SideDrawer = () => {
  const dispatch = useDispatch();

  const activeDrawer = useSelector(
    (state: RootState) => state.global.openDrawer
  );

  useEffect(() => {
    if (activeDrawer) {
      document.body.classList.add('noscroll');
    }

    return () => document.body.classList.remove('noscroll');
  }, [activeDrawer]);

  return (
    <Box
      className={activeDrawer ? 'active' : undefined}
      width={['100%', null, '600px']}
      height="100%"
      backgroundColor="background"
      position="fixed"
      top={0}
      right={0}
      zIndex={zIndices.SIDE_DRAWER}
      css={css`
        transition: transform 250ms ease-in-out;
        transform: translateX(1000px);
        &.active {
          transform: translateX(0);
        }
      `}
    >
      {activeDrawer && (
        <OutsideAlerter callback={() => void dispatch(closeDrawer())}>
          <Grid
            width="100%"
            maxWidth="100%"
            height="100%"
            px={[3, 4]}
            overflowX="hidden"
          >
            <Content active={activeDrawer} />
          </Grid>
        </OutsideAlerter>
      )}
    </Box>
  );
};

export default SideDrawer;
